<template>
  <div class="loading-bar" />
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

@keyframes loading-bar-animation {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(250%);
  }
}

.loading-bar {
  flex-shrink: 0;
  height: 3px;
  background-color: colors.$palette-brand-20;
  border-radius: 2px;
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    height: 100%;
    width: 40%;
    background-color: colors.$palette-brand-50;
    border-radius: 2px;
    animation: loading-bar-animation 1s ease-in-out infinite;
  }
}
</style>

<style lang="scss">
.loading-bar-enter-active,
.loading-bar-leave-active {
  transition: opacity 0.2s ease;
}

.loading-bar-enter-from,
.loading-bar-leave-to {
  opacity: 0;
}
</style>
